import { useRef } from 'react';

import { useConfirmDialogStore } from '@/shared/stores/confirm-dialog-store';

// A save in flight means the changes are already on their way, so every exit leaves at once.
// A getter reads the saving state at exit time, for a caller that holds it in a ref.
export function useDiscardChangesGuard(isSaving: boolean | (() => boolean)) {
    const openConfirmDialog = useConfirmDialogStore((state) => state.open);
    const isDirtyRef = useRef(false);

    const confirmDiscardChanges = (leave: () => void) => {
        const saving = typeof isSaving === 'function' ? isSaving() : isSaving;

        if (saving || !isDirtyRef.current) {
            leave();
            return;
        }

        openConfirmDialog({
            title: 'Discard unsaved changes?',
            confirmText: 'Discard',
            width: 'sm',
            onConfirm: leave,
        });
    };

    const setDirty = (isDirty: boolean) => {
        isDirtyRef.current = isDirty;
    };

    return { confirmDiscardChanges, setDirty };
}
